<template>
  <Dialog class="_component-welfare" size="big" @close="$emit('close')" title="限时福利">
    <div class="content-wrap">
      <div class="welfares-wrap">
        <div class="welfare-item" v-for="(item, index) in welfares" :key="index">
          <div class="item-img-wrap img-wrap">
            <img :src="item.img" alt="" />
          </div>
          <div class="item-info-wrap">
            <div class="item-info-top">
              <div class="item-name-wrap">
                <h3 class="h3 color-black-1">{{ item.name }}</h3>
                <div class="name-tag" v-if="item.tag">{{ item.tag }}</div>
              </div>
              <div class="text3 color-gray-2 mt-5" v-html="item.desc"></div>
            </div>
            <div class="item-info-footer">
              <div class="footer-left">
                <div class="hot-count-wrap text2 bold" v-if="item.count">
                  {{ item.count }}
                </div>
              </div>
              <p class="text2 color-gray-2" v-if="item.tip">{{ item.tip }}</p>
            </div>
          </div>
        </div>
      </div>
      <Button class="btn-next" @click="$emit('submit')">申请并领取</Button>
    </div>
  </Dialog>
</template>
<script>
import Button from 'components/FormRe/Button';
import welfares from './constants';
import Dialog from 'components/Dialog';
export default {
  name: 'Welfare',
  components: {
    Dialog,
    Button
  },
  computed: {
    welfares() {
      return welfares;
    }
  }
};
</script>
<style lang="less" scoped src="./index.less"></style>
